import { scroll } from './locomotive';

const selectors = {
  elems: '.js-parallax *',
};

const handleParallax = () => {
  const modifier = 5;
  let elems = document.querySelectorAll(selectors.elems);

  if (!elems.length) return;

  const changePosition = () => {
    elems.forEach((elem) => {
      let x =
        (elem.getBoundingClientRect().top - window.innerHeight) / modifier;
      let y = Math.round(x * 100) / 100;
      elem.style.backgroundPosition = 'center ' + y + 'px';
    });
  };

  scroll.on('scroll', changePosition);
};

export default handleParallax;
